export default [{
  path: 'dashboard',
  name: 'app.dashboard',
  component: () => import(/* webpackChunkName: 'marca' */'@/views/private/dashboard/Dashboard.vue'),
}];
